import React, { useContext, useEffect, useState } from "react";
import UserListView from "./UserListView";
import NoDataAvailable from "./NoDataAvailable";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axiosHttp from "../config/axios.interceptor";
import {
  getFollowerSuggestion,
  getFollowersList,
} from "../store/actions/userActions";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";

const SuggestForYou = ({ followerSuggestionList, path }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [followerSuggestions, setFollowerSuggestions] = useState([]);

  useEffect(() => {
    setFollowerSuggestions(followerSuggestionList);
  }, [followerSuggestionList]);
  const handleRequest = async (userId, status, follower) => {
    try {
      const followApi = await axiosHttp.post("follow", {
        userId,
        status,
      });
      if (followApi.status === 201) {
        const updatedSuggestions = followerSuggestions.filter(
          (suggestion) => suggestion.userId !== userId
        );
        setFollowerSuggestions(updatedSuggestions);
        dispatch(getFollowerSuggestion(appContext.category));
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: `You gave  follow request to ${follower?.fName} ${follower?.lName}`,
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: "Error, please try after sometime.",
      });
    }
  };

  return (
    <div className="card mt-2">
      <div className="card-body">
        <p className="follow-txt">Suggested for you </p>
        <>
          {followerSuggestions.map((followerSuggestion, index) => (
            <UserListView
              key={index}
              user={followerSuggestion}
              isSibebarDisplay={true}
            >
              <button
                type="button"
                className="btn btn-outline-primary follow-btn btn-sm"
                onClick={() =>
                  handleRequest(
                    followerSuggestion.userId,
                    "R",
                    followerSuggestion
                  )
                }
              >
                Follow
              </button>
            </UserListView>
          ))}
        </>

        {path !== "/my-network" && followerSuggestionList.length !== 0 && (
          <>
            <hr />
            <p
              className="text-center text-primary mb-0 cursor-pointer"
              onClick={() => navigate("../my-network")}
            >
              <b>See All</b>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default SuggestForYou;
